import { motion } from "framer-motion";

/**
 * Reusable hero header for inner pages — sits below the sticky navbar.
 */
const PageHeader = ({ tag, title, accent, subtitle }) => {
  return (
    <section className="relative pt-36 pb-16 md:pt-44 md:pb-24 bg-[#0B132B] overflow-hidden">
      {/* hatch + grain */}
      <div className="absolute inset-0 hatch-pattern opacity-40" aria-hidden />
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at top right, rgba(212,122,74,0.10), transparent 60%)",
        }}
        aria-hidden
      />
      {/* copper bar */}
      <div
        className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-32 bg-[#D47A4A] hidden lg:block"
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-xs uppercase tracking-[0.3em] text-[#D47A4A] mb-4"
        >
          {tag}
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.05 }}
          className="font-display text-5xl md:text-7xl text-white leading-[0.95] tracking-tight"
        >
          {title}{" "}
          {accent && <span className="text-[#D47A4A]">{accent}</span>}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-6 text-base md:text-lg text-[#A0ABC0] max-w-2xl"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
